import script from "./SidebarComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./SidebarComponent.vue?vue&type=script&lang=ts&setup=true"

import "./SidebarComponent.vue?vue&type=style&index=0&id=4b0a9c2e&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b0a9c2e"]])

export default __exports__